module.exports = __webpack_public_path__ + "img/QuotationMarks.89a71c43.png";